exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".media-cell{text-align:center}.media-cell .icon-wrapper .icon-wrapper__icon{font-size:24px;color:#a1d2f7;border-radius:4px;padding:2px;margin-right:4px;cursor:pointer}.media-cell .icon-wrapper .icon-wrapper__icon:hover{color:#259af4;background-color:#e7e9ee}.media-cell .media-cell__duration{vertical-align:top}.media-cell--text{display:flex;text-align:left;word-break:break-word}.media-cell--text .icon-wrapper .icon-wrapper__icon{font-size:12px}", ""]);

// exports
